import { RouterModule, Routes } from '@angular/router';

import { AuthUserService } from './services/auth-user-service/auth-user.service';

import { AuthzoneComponent } from './authzone/authzone.component';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ProjectsSearchComponent, ProposalsSearchComponent, ProposalsPeSearchComponent } from './projects-search/projects-search.component';
import { ClientsSocisComponent } from './clientsSocis/clientssocis.component';
import { ManageClientsSocisComponent } from './clientsSocis/manage-clientssocis/manage-clientssocis.component';
import { ContactesComponent } from './contactes/contactes.component';
import { ManageContactesComponent } from './contactes/manage-contactes/manage-contactes.component';
import { SeguimentTecnicComponent } from './seguiment-tecnic-cercador/seguiment-tecnic.component';
import { CalendarsComponent } from './calendars/calendars.component';
import { FacturaCercadorComponent } from './factures-cercador/factures-cercador.component';
import { FacturaRebCercadorComponent } from './factures-reb-cercador/factures-reb-cercador.component';
import { ManageUsersComponent } from './manage-users/manage-users.component';
import { ManageCurriculumComponent } from './manage-curriculum/manage-curriculum.component';
import { DocumentsCercadorComponent } from './documents-cercador/documents-cercador.component';
import { ManageSeguimentTecnicComponent } from './manage-seguiment-tecnic-projectes/manage-seguiment-tecnic.component';
import { ManageInvoiceComponent } from './manage-invoice/manage-invoice.component';
import { ManageInvoiceRebComponent } from './manage-invoice-reb/manage-invoice-reb.component';
import { InvoicesComponent } from './invoices/invoices.component';
import { TicketingComponent } from './ticketing-cercador/ticketing.component';
import { InvoicesRebComponent } from './invoices-reb/invoices-reb.component';
import { OportunitatsComponent } from './oportunitats/oportunitats.component';
import { UtesComponent } from './utes/utes.component';
import { NotesComponent } from './notes/notes.component';
import { ConcursosComponent } from './concursos/concursos.component';
import { AiSearchComponent } from './chatgpt-ai/chatgpt-ai-search.component';
import { ManageProjectComponent, ManageProposalComponent, ManageProposalPeComponent }   from './manage-project/manage-project.component';
import { ProjectHourControlComponent, ProposalHourControlComponent }   from './hour-control/hour-control.component';
import { ReportsComponent }   from './reports/reports.component';

const routes: Routes = [
  {path: 'login', component: LoginComponent
    },
  { path: '', component: AuthzoneComponent, canActivate: [AuthUserService],
    children : [
      {path: 'dashboard', component: DashboardComponent},
      {path: 'project/:id', component: ManageProjectComponent},
      {path: 'project/:id/invoices', component: ManageInvoiceComponent},
      {path: 'project/:id/invoicesReb', component: ManageInvoiceRebComponent},
      {path: 'projects', component: ProjectsSearchComponent},
      {path: 'solvencies', component: ConcursosComponent},
      {path: 'projects/hours', component: ProjectHourControlComponent},
      {path: 'proposals', component: ProposalsSearchComponent},
      {path: 'proposalpe/:id', component: ManageProposalPeComponent}, 
      {path: 'proposalpe', component: ProposalsPeSearchComponent},     
      {path: 'propostes/hours', component: ProposalHourControlComponent},
      {path: 'proposal/:id', component: ManageProposalComponent},
      {path: 'calendars', component: CalendarsComponent},
      {path: 'users', component: ManageUsersComponent},
      {path: 'curriculum', component: ManageCurriculumComponent},
      {path: 'invoices', component: InvoicesComponent},
      {path: 'invoices-reb', component: InvoicesRebComponent},
      {path: 'oportunitats', component: OportunitatsComponent},
      {path: 'utes', component: UtesComponent},
      {path: 'quefaig', component: NotesComponent},
      {path: 'documents', component: DocumentsCercadorComponent},
      {path: 'clientssocislist', component: ClientsSocisComponent},
      {path: 'contactes', component: ContactesComponent},
      {path: 'fitxaclientssocis/:id', component: ManageClientsSocisComponent},
      {path: 'fitxaContactes/:id', component: ManageContactesComponent},
      {path: 'reports', component: ReportsComponent},
      {path: 'ticketing', component: TicketingComponent},
      {path: 'ai', component: AiSearchComponent},
      {path: 'invoiceslist', component: FacturaCercadorComponent},
      {path: 'seguimenttecnic', component: SeguimentTecnicComponent},
      {path: 'project/:id/seguimentTecnic', component: ManageSeguimentTecnicComponent},
      {path: 'invoicesreblist', component: FacturaRebCercadorComponent},
      {path: 'dedicacions', loadChildren: () => new Promise( () => {window.location.href = 'https://sg.mcrit.com/dedicacions/';})},
      {path: '', redirectTo: '/login', pathMatch: 'full'}
    ]},
];

export const appRoutingProviders: any[] = [];
export const routing = RouterModule.forRoot(routes,{useHash: true});